import { getGreeting } from '@shared/greeting';
import { getDateShort, getDateTimeFromUtcToLocal } from '@shared/entity';
import { Service } from '@features/service/entity';

export { capitalizeFirstLetter } from '@shared/greeting';

export type SmsPlaceholderData = {
  clientName?: string;
  depositAmount?: string;
  appointmentDate?: string;
  appointmentTime?: string;
  reviewUrl?: string;
  reason?: string;
  serviceName?: string;
  bankAccount?: string;
};

/**
 * Nahradí placeholdery v šabloně skutečnými hodnotami
 */
export const renderSmsTemplate = (template: string, data: SmsPlaceholderData): string => {
  let renderedMessage = template;

  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      const placeholder = `{${key}}`;
      const regex = new RegExp(placeholder.replace(/[{}]/g, '\\$&'), 'g');
      renderedMessage = renderedMessage.replace(regex, String(value));
    }
  });

  return renderedMessage;
};

/**
 * Formátuje jméno klienta podle příjmení (oslovení + 5. pád)
 */
export const formatClientName = (lastName: string): string => {
  // Templates already supply punctuation after {clientName}.
  return getGreeting(lastName).replace(/,\s*$/, '');
};

/**
 * Zformátuje pouze den a měsíc (bez roku a času)
 * Příklad: "16.11."
 */
export const formatDateOnlyForSms = (date: Date): string => {
  return getDateShort(date);
};

/**
 * Zformátuje pouze čas (bez data)
 * Příklad: "14:00"
 */
export const formatTimeOnlyForSms = (date: Date): string => {
  const dateStr = getDateTimeFromUtcToLocal(date);
  // Extrahuje čas z formátu "16. 11. 2025 14:00"
  const parts = dateStr.split(' ');
  return parts[parts.length - 1]; // Poslední část je čas
};

/**
 * Zformátuje seznam služeb
 */
export const formatServicesForSms = (services: Service[]): string => {
  return (
    services
      ?.map(service => service?.serviceName?.trim())
      .filter(Boolean)
      .join(', ') || 'službu'
  );
};

/**
 * Zformátuje částku zálohy
 */
export const formatDepositAmount = (amount: string | undefined): string => {
  return amount ? `${amount}` : 'CHYBÍ VÝŠE ZÁLOHY';
};
